export const checkTimeInRange = (
  array: { label: string; value: string }[],
  string: string,
): boolean => {
  let found = false;
  array.forEach((obj) => {
    if (obj.value === string) {
      found = true;
    }
  });
  return found;
};
